<div style="padding-top: 18%">

</div>

<div class="modal show" id="disclaimer" role="dialog" #disclaimerModal>
  <div class="modal-dialog">
    <div class="modal-content bmw-login-lg-modal">
      <div class="modal-header">

        <h4 class="modal-title color-primary">
          <b>
            <span>{{brandName()}}</span> Service Information Disclaimer</b>
        </h4>
      </div>
      <div class="modal-body">
        <small style="color:black">
          <p>All subscribers to this website are authorized to use the information solely for the purpose of servicing
            and/or repairing unmodified BMW or MINI vehicles manufactured for sale in the USA including Puerto Rico.</p>
          <p>In order to facilitate the transaction herein, certain portions of this website connect to the BMW
            Aftersales Online System (AOS) servers and includes the transmission of the following data: Name,
            Address, Email, and Telephone Number as specified in your user profile.
            The information on this website is not to be resold, bartered, copied or transferred without the express
            written consent of BMW of North America, LLC ("BMW NA"). BMW NA shall not be liable for any programming
            aborts, vehicle no-start situations, or control module failures that may occur while using a pass through
            tool, or ICOM interface and this website; or any other unauthorized or improper use of the website or the
            information therein.</p>
          {{copyright()}}
          <br /><br />

        </small>
        <div class="options">
          <button type="submit" class="primary-button" (click)='home()' data-dismiss="modal">I
            Agree
          </button>
          <button type='submit' class="primary-button" (click)='login()'>I
            Disagree
          </button>
        </div>
      </div>
    </div>
  </div>
</div>